/** 도구 카드 — 호출/결과 한 장. 라벨은 사람이 읽는 이름(식별자 노출 금지 — F-0 L4). */
import { useTranslation } from 'react-i18next'

import { Wrench } from '@/ui/icons'
import type { ToolPart } from './events'

export function ToolCard({ part }: { part: ToolPart }) {
  const { t } = useTranslation()
  const running = part.phase === 'call'
  const hasDetail = Boolean(
    (part.args && Object.keys(part.args).length > 0) || part.content,
  )

  return (
    /* <details> 를 쓰는 이유: 접힘 상태가 DOM 에 있어야 키보드·스크린리더가 "더 있다"를 안다.
       useState 로 만든 접힘은 보이는 사람에게만 접힘이다. */
    <details className="toolgroup">
      <summary>
        {running ? (
          <span className="spinner tool-run" aria-hidden="true" />
        ) : (
          <Wrench size={14} />
        )}
        <span className="name">{part.label}</span>
        <span className="tool-note">{running ? t('tool.running') : t('tool.done')}</span>
        {hasDetail && <span className="chev" aria-hidden="true" />}
      </summary>
      {hasDetail && (
        <div className="tool-detail">
          {part.args && Object.keys(part.args).length > 0 && (
            <pre>{JSON.stringify(part.args, null, 2)}</pre>
          )}
          {part.content && <p>{part.content}</p>}
        </div>
      )}
    </details>
  )
}
